import script from "./auctions-page.vue?vue&type=script&setup=true&lang=js"
export * from "./auctions-page.vue?vue&type=script&setup=true&lang=js"

import "./auctions-page.vue?vue&type=style&index=0&id=c95c4ce2&lang=css"

const __exports__ = script;

export default __exports__